module.exports = __webpack_public_path__ + "media/components/src/assets/images/text_type_4-c1771ba5470a5ec79048c22eabe5d24d.jpg";